import React from "react";
import { clsx } from "clsx";
import { StyledContainer } from "../../Styled/Container";
import { type SellingPointsOutputProps } from "./withSellingPoints";

const Container = (props: any) => (
  <StyledContainer
    {...props}
    className={clsx(props.className, "pb-mega md:pb-giga")}
  />
);

const Point = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "flex flex-wrap items-center pb-midi md:pb-maxi",
    )}
  />
);

const Title = (props: any) => (
  <h3
    {...props}
    className={clsx(
      props.className,
      "block w-full font-display text-h4 leading-caption md:w-1/3 md:text-[32px] md:leading-body",
    )}
  />
);

const Description = (props: any) => (
  <p
    {...props}
    className={clsx(
      props.className,
      "block w-full text-body leading-body md:w-2/3 md:pl-maxi",
    )}
  />
);

const SellingPointsList = ({
  points,
  width,
}: Partial<SellingPointsOutputProps>) => {
  if (!points?.length) {
    return;
  }

  return (
    <Container width={width} data-testid="selling-points-list">
      {points.map(({ title, description }) => (
        <Point key={title}>
          <Title>{title}</Title>
          <Description>{description}</Description>
        </Point>
      ))}
    </Container>
  );
};

export default SellingPointsList;
